module.exports = __webpack_public_path__ + "img/arm-articulated-claw.075c1fa9.png";